<!-- SearchModulesAndTopics page -->
<template>
  <div ref="whole_page" class="text-left">
    <div class="vx-row">
      <div class="vx-col xl:w-2/3 lg:w-3/4 md:w-4/5 sm:w-5/6 xs:w-5/6 w-5/6 mx-auto">
        <div id="dashboard-search-container" class="w-full">
          <div class="inline-flex w-full p-1">
            <feather-icon icon="ArrowRightCircleIcon" width="20" height="20" svgClasses="h-4 w-4" />
            <input type="text" @keyup.enter="executeSearch" class="form-control" placeholder="Search Modules or Topics..." v-model="query">
            <feather-icon icon="SearchIcon" width="20" height="20" svgClasses="h-4 w-4" style="cursor: pointer;" @click="executeSearch" />
          </div>
        </div>
        <div class="mb-base mt-3">
          <!-- <p id="search-options-label" class="text-center">Search Options</p> -->
          <p v-if="!advancedSearchActive" id="search-options-label" class="text__school-tertiary-color underline__hover-only text-center" @click="advancedSearchActive = true;getLanguagesWithGrades();"><small><strong>Search Options</strong></small></p>

          <vx-card v-else ref="search_options_card" class="vs-con-loading__container">
            <div class="vx-row">
              <div class="vx-col w-full">
                <vx-card class="card__no-padding" style="width: 277px">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text">
                        <span><feather-icon class="pt-1" icon="MessageCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button :disabled="true"
                              size="large"
                              class="button__fully-opaque button-text__left-align header_button-lookalike text__school-tertiary-color"
                              type="filled"
                              color="">
                      {{ studentLanguageWithAllGrades.name }}
                    </vs-button>
                  </vx-input-group>
                </vx-card>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col" v-for="(_grade, index) in studentLanguageWithAllGrades.grades" :key="index">
                <vx-card class="glow-effect_dark mb-3 card__no-padding bg-color" style="width: 220px !important">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text input-group_prepend-slot-bg">
                        <span><vs-checkbox color="success" v-model="_grade.selected" /></span>
                      </div>
                    </template>

                    <vs-button size="large"
                              class="w-full button__fully-opaque button-text__left-align school-primary_gradient"
                              style="border-radius:0 7px 7px 0;padding: 0.6rem 1rem !important;"
                              @click="_grade.selected = !_grade.selected">
                      {{ _grade.name }}
                    </vs-button>
                  </vx-input-group>
                </vx-card>
              </div>
            </div>
            <p v-if="!moreLanguagesVisible" id="search-options-label" class="text__school-tertiary-color underline__hover-only text-left mt-3" @click="moreLanguagesVisible = true"><strong>More Languages</strong></p>
            <div v-else>
              <div v-for="(_language, index) in languagesWithGrades" :key="index">
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <vx-card class="card__no-padding" style="width: 277px">
                      <vx-input-group>
                        <template slot="prepend">
                          <div class="prepend-text">
                            <span><feather-icon class="pt-1" icon="MessageCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                          </div>
                        </template>

                        <vs-button :disabled="true"
                                  size="large"
                                  class="button__fully-opaque button-text__left-align header_button-lookalike text__school-tertiary-color"
                                  type="filled"
                                  color="">
                          {{ _language.name }}
                        </vs-button>
                      </vx-input-group>
                    </vx-card>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col" v-for="(_grade, index) in _language.grades" :key="index">
                    <vx-card class="glow-effect_dark mb-3 card__no-padding bg-color" style="width: 220px !important">
                      <vx-input-group>
                        <template slot="prepend">
                          <div class="prepend-text input-group_prepend-slot-bg">
                            <span><vs-checkbox color="success" v-model="_grade.selected" /></span>
                          </div>
                        </template>

                        <vs-button size="large"
                                  class="w-full button__fully-opaque button-text__left-align school-primary_gradient"
                                  style="border-radius:0 7px 7px 0;padding: 0.6rem 1rem !important;"
                                  @click="_grade.selected = !_grade.selected">
                          {{ _grade.name }}
                        </vs-button>
                      </vx-input-group>
                    </vx-card>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row mt-2">
              <div class="vx-col w-full centereverything">
                <vs-button icon-pack="feather" icon="icon-search" color="success" style="border-radius: 30px !important;background-color: rgba(40,199,111,0.7) !important" @click="executeSearch">Apply & Search</vs-button>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
    <div v-if="categories.length == 0 && modules.length == 0" class="vx-row">
      <div class="vx-col w-full">
        <p class="centereverything" style="font-weight: 700;font-size:14pt">No results</p>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col xl:w-2/3 lg:w-3/4 md:w-4/5 sm:w-5/6 xs:w-5/6 w-5/6 mx-auto">
        <vs-table
          v-if="categories.length > 0"
          stripe
          ref="categoriesTable"
          class="vs-con-loading__container"
          single
          @selected="handleSelectedCategory"
          pagination
          max-items="10"
          :data="categories"
        >
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <h3>Modules</h3>
          </div>
          <template slot="thead">
            <vs-th sort-key="gradeName">Grade</vs-th>
            <vs-th sort-key="courseName">Subject</vs-th>
            <vs-th sort-key="name">Module</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              :data="category"
              :key="indextr"
              v-for="(category, indextr) in data"
            >
              <vs-td :data="data[indextr].gradeName">
                {{ category.gradeName }}
              </vs-td>

              <vs-td :data="data[indextr].courseName">
                {{ category.courseName }}
              </vs-td>

              <vs-td :data="data[indextr].name">
                {{ category.name }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col xl:w-2/3 lg:w-3/4 md:w-4/5 sm:w-5/6 xs:w-5/6 w-5/6 mx-auto">
        <vs-table
          v-if="modules.length > 0"
          stripe
          ref="modulesTable"
          class="vs-con-loading__container"
          single
          @selected="handleSelectedModule"
          pagination
          max-items="10"
          :data="modules"
        >
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <h3>Topics</h3>
          </div>
          <template slot="thead">
            <vs-th sort-key="gradeName">Grade</vs-th>
            <vs-th sort-key="courseName">Subject</vs-th>
            <vs-th sort-key="name">Module</vs-th>
            <vs-th sort-key="termName">Term</vs-th>
            <vs-th sort-key="topicName">Topic</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              :data="mod"
              :key="indextr"
              v-for="(mod, indextr) in data"
            >
              <vs-td :data="data[indextr].gradeName">
                {{ mod.gradeName }}
              </vs-td>

              <vs-td :data="data[indextr].courseName">
                {{ mod.courseName }}
              </vs-td>

              <vs-td :data="data[indextr].name">
                {{ mod.name }}
              </vs-td>

              <vs-td :data="data[indextr].termName">
                {{ mod.termName }}
              </vs-td>

              <vs-td :data="data[indextr].topicName">
                {{ mod.topicName }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import defaultIcon from '@/digicampus/assets/subjecticons/default.svg'
import mathsIcon from '@/digicampus/assets/subjecticons/maths.svg'
import mathsliteracyIcon from '@/digicampus/assets/subjecticons/maths-literacy.svg'
import afrikaanshomeIcon from '@/digicampus/assets/subjecticons/afrikaans-home.svg'
import afrikaansfirstIcon from '@/digicampus/assets/subjecticons/afrikaans-first.svg'
import englishhomeIcon from '@/digicampus/assets/subjecticons/english-home.svg'
import englishfirstIcon from '@/digicampus/assets/subjecticons/english-first.svg'
import lifeskillsIcon from '@/digicampus/assets/subjecticons/life-skills.svg'
import lifesciencesIcon from '@/digicampus/assets/subjecticons/life-sciences.svg'
import socialscienceIcon from '@/digicampus/assets/subjecticons/social-science.svg'
import lifeorientationIcon from '@/digicampus/assets/subjecticons/life-orientation.svg'
import naturalscienceandtechnologyIcon from '@/digicampus/assets/subjecticons/natural-science-and-technology.svg'
import geographyIcon from '@/digicampus/assets/subjecticons/geography.svg'
import economicsIcon from '@/digicampus/assets/subjecticons/economics.svg'
import accountingIcon from '@/digicampus/assets/subjecticons/accounting.svg'
import tourismIcon from '@/digicampus/assets/subjecticons/tourism.svg'
import naturalscienceIcon from '@/digicampus/assets/subjecticons/natural-science.svg'
import historyIcon from '@/digicampus/assets/subjecticons/history.svg'
import egdIcon from '@/digicampus/assets/subjecticons/eng-graphics-and-design.svg'
import technologyIcon from '@/digicampus/assets/subjecticons/technology.svg'
import computerapptechnologyIcon from '@/digicampus/assets/subjecticons/computer-app-technology.svg'
import itIcon from '@/digicampus/assets/subjecticons/it.svg'
import electricaltechnologyIcon from '@/digicampus/assets/subjecticons/electrical-technology.svg'
import mechanicaltechnologyIcon from '@/digicampus/assets/subjecticons/mechanical-technology.svg'
import civiltechnologyIcon from '@/digicampus/assets/subjecticons/civil-technology.svg'
import businessstudiesIcon from '@/digicampus/assets/subjecticons/business-studies.svg'
import consumerstudiesIcon from '@/digicampus/assets/subjecticons/consumer-studies.svg'
import physicalscienceIcon from '@/digicampus/assets/subjecticons/physical-science.svg'
import chessIcon from '@/digicampus/assets/subjecticons/chess.svg'
import creativeartsIcon from '@/digicampus/assets/subjecticons/creative-arts.svg'
export default {
  components: {},
  data() {
    return {
      resultData: {},
      categories: [],
      modules: [],
      query: "",
      gradeId: null,
      math: [38,39,47,51,54,55,56,57,58,59,89,130,139,141,143,145,148,150,176,189,196,225,236,248,259,261,341,361,367,380,388,389,398,400,408,412,417],
      mathLit: [44,115,124,266,268,269,349,368,393],
      afrHuis: [40,41,60,61,62,63,165,201,202,204,250,252,258],
      afrEat: [46,64,78,80,91,200,206,211,213,238,239,240,676],
      engHome: [52,90,92,98,100,131,215,228,232,235,244,245,246],
      engFal: [53,81,82,83,132,163,192,193,195,241,242,243,332,343,370,390,399,518],
      lifeSkill: [45,49,79,88,103,104,109,110,197,198,334,409,410,414,421],
      lifeScience: [48,106,113,310,311,313,359,371,395],
      socScience: [71,72,116,117,118,119,126,184,186,187,205,207],
      lifeOrient: [84,85,86,154,155,157,249,251,253,255,256,257,527],
      natSciTech: [42,50,74,77,185,191],
      geography: [94,95,96,97,99,105,344,378,391],
      econManSci: [120,122,125,175,177,178],
      economics: [128,133,135,229,230,231,354,376,394],
      accounting: [136,138,146,210,212,216,345,373,392],
      tourism: [156,158,160,180,199,348,372,403,511,512,513],
      natScience: [111,112,114,181,182,183],
      history: [140,142,144,147,149,151,342,374,404,429],
      egd: [127,129,134,260,263,267],
      tech: [171,172,174,188,190,194],
      compAppTech: [137,152,161,214,220,223],
      it: [164,167,179,270,271,272],
      elecTech: [291,292,293],
      mechTech: [315,316,317],
      civilTech: [318,319,320],
      busStudy: [153,159,166,219,221,222,346,365,405,495,506,507],
      consStud: [168,170,173,233,234,237],
      physScience: [208,209,218,224,226,227,347,369,397],
      chess: [335,336,337,338],
      agriSci: [350,366,402],
      arts: [362],
      isixhosa: [333,352,387,401],
      advancedSearchActive: false,
      languagesWithGrades: [],
      studentLanguageWithAllGrades: {},
      moreLanguagesVisible: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    executeSearch() {
      var self = this;
      
      if (self.query) {
        self.showLoadingOnElement("whole_page", 1, "material");

        var gradesToSearch = [];

        if (self.advancedSearchActive) {
          self.languagesWithGrades.forEach(_langauge => {
            _langauge.grades.filter(x => x.selected).map(x => x.id).forEach(x => gradesToSearch.push(x))
          });

          self.studentLanguageWithAllGrades.grades.filter(x => x.selected).map(x => x.id).forEach(x => gradesToSearch.push(x));
        } else {
          var gradeId = self.gradeId ? self.gradeId : gradeIdParam;
          gradesToSearch.push(gradeId);
        }

        var searchData = {
          searchQuery: self.query,
          gradeIds: gradesToSearch
        }

        var onSuccess = function (response) {
          self.categories = [];
          self.modules = [];

          self.resultData = response.data;

          self.categories = Array.from(
            new Set(self.resultData.map((x) => x.moduleCategoryId))
          ).map((id) => {
            var item = self.resultData.find((x) => x.moduleCategoryId == id && x.type == 1);
            if (item) {
              return {
                id: id,
                name: item.moduleCategoryName,
                courseId: item.courseId,
                courseName: item.courseName,
                gradeName: item.gradeName,
              };
            }
          });

          // self.categories = self.resultData.map((item) => {
          //   return {
          //     id: item.id,
          //     name: item.moduleCategoryName,
          //     courseId: item.courseId,
          //     courseName: item.courseName,
          //     gradeName: item.gradeName,
          //     type: item.type
          //   };
          // });

          if (!self.categories[0]) {
            self.categories = [];
          }

          self.modules = self.resultData.map((item) => {
            return {
              id: item.id,
              name: item.moduleCategoryName,
              courseId: item.courseId,
              courseName: item.courseName,
              topicId: item.id,
              topicName: item.name,
              termId: item.moduleGroupId,
              termName: item.moduleGroupName,
              gradeName: item.gradeName,
              type: item.type
            };
          });

          self.modules = self.modules.filter(x => x.type == 2);

          if (!self.modules[0]) {
            self.modules = [];
          }

          if (self.$refs.categoriesTable) {
            self.$refs.categoriesTable.currentPage = 1;
            self.$refs.categoriesTable.currentx = 1;
          }
          
          if (self.$refs.modulesTable) {
            self.$refs.modulesTable.currentPage = 1;
            self.$refs.modulesTable.currentx = 1;
          }
        };

        var onFinally = function (response) {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        };

        self.$ajaxPost(
          self,
          `Student/SearchModulesTopics`,
          searchData,
          onSuccess,
          onFinally
        );
      } else {
        self.$vs.notify({
          title:'Error',
          color: "warning",
          text: "Search cannot be empty",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-x',
          time: 5000
        });
      }
    },
    handleSelectedCategory(category) {
      var self = this;

      var selectedData = {
        selectedSubject: {
          id: category.courseId,
          name: category.courseName,
          icon: self.getIcon(category.courseId)
        },
        selectedModule: {
          id: category.id,
          name: category.name
        }
      };

      self.$router.push({ name: 'BrowseContent', params: { selectedData: selectedData, navFromSearchModule: true } });
    },
    handleSelectedModule(module) {
      var self = this;

      var selectedData = {
        selectedSubject: {
          id: module.courseId,
          name: module.courseName,
          icon: self.getIcon(module.courseId)
        },
        selectedModule: {
          id: module.id,
          name: module.name
        },
        selectedTopic: {
          id: module.topicId,
          name: module.topicName
        }
      };

      self.$router.push({ name: 'BrowseContent', params: { selectedData: selectedData, navFromSearchTopic: true } });
    },
    getIcon(id) {
      var self = this;
              
      if (self.math.includes(id))
        return mathsIcon;
      else if (self.mathLit.includes(id))
        return mathsliteracyIcon;
      else if (self.afrHuis.includes(id))
        return afrikaanshomeIcon;
      else if (self.afrEat.includes(id))
        return afrikaansfirstIcon;
      else if (self.engHome.includes(id))
        return englishhomeIcon;
      else if (self.engFal.includes(id))
        return englishfirstIcon;
      else if (self.lifeSkill.includes(id))
        return lifeskillsIcon;
      else if (self.lifeScience.includes(id))
        return lifesciencesIcon;
      else if (self.socScience.includes(id))
        return socialscienceIcon;
      else if (self.lifeOrient.includes(id))
        return lifeorientationIcon;
      else if (self.natSciTech.includes(id))
        return naturalscienceandtechnologyIcon;
      else if (self.geography.includes(id))
        return geographyIcon;
      else if (self.economics.includes(id))
        return economicsIcon;
      else if (self.accounting.includes(id))
        return accountingIcon;
      else if (self.tourism.includes(id))
        return tourismIcon;
      else if (self.natScience.includes(id))
        return naturalscienceIcon;
      else if (self.history.includes(id))
        return historyIcon;
      else if (self.egd.includes(id))
        return egdIcon;
      else if (self.tech.includes(id))
        return technologyIcon;
      else if (self.compAppTech.includes(id))
        return computerapptechnologyIcon;
      else if (self.it.includes(id))
        return itIcon;
      else if (self.elecTech.includes(id))
        return electricaltechnologyIcon;
      else if (self.mechTech.includes(id))
        return mechanicaltechnologyIcon;
      else if (self.civilTech.includes(id))
        return civiltechnologyIcon;
      else if (self.busStudy.includes(id))
        return businessstudiesIcon;
      else if (self.consStud.includes(id))
        return consumerstudiesIcon;
      else if (self.physScience.includes(id))
        return physicalscienceIcon;
      else if (self.chess.includes(id))
        return chessIcon;
      else if (self.arts.includes(id))
        return creativeartsIcon;
      else
        return defaultIcon;
    },
    getLanguagesWithGrades() {
      var self = this;
      if (self.$refs.search_options_card) {
        self.showLoadingOnElement('search_options_card', 1, 'material');
      }

      var onSuccess = function(response) {
        if (response.data && response.data.length >= 0) {
          var allData = response.data;

          self.languagesWithGrades = Array.from(new Set(allData.map(x => x.language)))
            .map(value => { 
              return { 
                id: allData.find(x => x.language == value).languageId,
                name: allData.find(x => x.language == value).language,
                grades: allData.filter(x => x.language == value).map(x => { return { id: x.gradeId, name: x.grade, groupId: x.gradeGroupId, selected: x.selected } })//.sort((a, b) => { return a.name > b.name ? 1 : -1; })
              } 
            });

          var userInfo = JSON.parse(localStorage.getItem("userInfo"));

          var studentLanguageId = userInfo.languageId;
          var studentGradeId = userInfo.courseClassificationId;
          self.studentLanguageWithAllGrades = self.languagesWithGrades.filter(x => x.id == studentLanguageId)[0];

          self.studentLanguageWithAllGrades.grades.filter(x => x.id == studentGradeId)[0].selected = true;

          self.languagesWithGrades = self.languagesWithGrades.filter(x => x.id != studentLanguageId);
        }
      };

      var onFinally = function() {
        if (self.$refs.search_options_card) {
          self.$vs.loading.close(self.$refs.search_options_card.$el);
        }
      };

      self.$ajaxGet(self, "Language/GetLanguagesWithGrades", onSuccess, onFinally);
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale,
      });
    },
  },
  mounted() {
    var self = this;
    self.gradeId = self.$route.query.gradeId;
    self.query = self.$route.query.query;
    self.executeSearch();
  },
};
</script>
<style lang="scss">
  #search-options-label {
    cursor: pointer;
    font-size: 11pt;
    font-weight: 500;
    &:hover {
      text-decoration: underline;
    }
  }
</style>